<template>
  <v-card
      outlined
  >
    <v-card-text>
      <v-list-item three-line>
        <v-list-item-avatar
            color="#F5F6F7"
            rounded
            width="64"
            height="64"
            style="cursor: pointer"
            @click="toAppDetails"
        >
          <v-icon size="40">
            mdi-unity
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
              @click="toAppDetails"
              style="cursor: pointer;"
          >
            {{item.name}}
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="app-id">Application ID: {{item.id}}</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            Status:
            <v-icon :color="statusColor">mdi-circle-medium</v-icon>
            {{statusText}} &nbsp;
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-icon>mdi-shield-star-outline</v-icon>
      Owner
      <v-spacer/>
      <v-menu
          bottom
          left>
        <template v-slot:activator="{on, attrs}">
          <v-btn
              icon
              v-bind="attrs"
              v-on="on">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="item.status === 'active'" @click="deActiveApp">
            <v-list-item-title>Deactive Application</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="item.status === 'inactive'" @click="activeApp">
            <v-list-item-title>Active Application</v-list-item-title>
          </v-list-item>
          <v-list-item @click="remove(item.id)">
            <v-list-item-title>Remove Application</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "ApplicationItemBox",
  props: {
    item: {}
  },
  computed: {
    statusColor() {
      return this.item.status === 'active' ? 'green' : '';
    },
    statusText() {
      return this.item.status === 'active' ? 'Active': 'Inactive'
    }
  },
  methods: {
    ...mapActions('application', ['remove', 'updateWithConfirm']),
    toAppDetails() {
      this.$router.push(`/applications/${this.item.id}`)
    },
    activeApp() {
      const newItem = {
        ...this.item,
        status: 'active'
      }
      this.updateWithConfirm(newItem)
    },
    deActiveApp() {
      const newItem = {
        ...this.item,
        status: 'inactive'
      }
      this.updateWithConfirm(newItem)
    }
  }
}
</script>

<style scoped lang="scss">
.app-id {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>
